import { render, staticRenderFns } from "./AddedtoJD.vue?vue&type=template&id=a97e5778&scoped=true&"
import script from "./AddedtoJD.vue?vue&type=script&lang=js&"
export * from "./AddedtoJD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97e5778",
  null
  
)

export default component.exports